import { COLLECTION_IDS } from '@/constants/collections';
import { IFilterGridItem } from '@/interfaces/constructor.interfaces';
import { ISettings } from '@/interfaces/settings.interfaces';

import { FiltersParametersType } from '../types';

import getCompositeFilterField from './getCompositeFilterField';

const transformFiltersIntoFields = (
  filters: IFilterGridItem[],
): Record<string, string> => {
  const fields = filters.reduce<Record<string, string>>((acc, item) => {
    const itemFields = getCompositeFilterField(item);
    return { ...acc, ...itemFields };
  }, {});
  return fields;
};

const getFiltersParameters = (
  settings: ISettings,
  filters: IFilterGridItem[],
  filter: FiltersParametersType['filter'],
): FiltersParametersType => {
  const { spaceId, envId } = settings;

  return {
    spaceId,
    envId,
    collectionId: COLLECTION_IDS.vehiclesVehicles,
    filter,
    options: {
      fields: transformFiltersIntoFields(filters),
    },
  };
};

export default getFiltersParameters;
